var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 40,
    fill: "#5EC361"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2193 58.3289C32.4038 58.1809 32.6574 58.1562 32.8649 58.3043C33.0724 58.4523 33.3721 58.5757 33.7871 58.6003C34.6631 58.625 36.2078 58.1069 38.4903 55.3683C38.6978 55.1216 39.0436 55.0969 39.2972 55.319C39.5047 55.5163 39.5508 55.8617 39.3894 56.1085C38.9283 56.9226 38.4903 57.8108 38.2597 58.403L38.2828 58.3783C38.3058 58.3783 38.3058 58.3536 38.3289 58.3536C39.2511 57.7862 40.6574 56.7746 40.9571 56.3552C41.0955 56.1578 41.3491 56.0591 41.5796 56.1331C41.9485 56.2565 42.0868 56.7006 41.9024 57.0213C41.4643 57.8108 41.1185 58.7977 41.1416 59.1431C41.1877 59.1431 41.2569 59.1431 41.3721 59.0938C41.9946 58.9211 42.2943 58.699 42.571 58.5016C42.8476 58.2796 43.1704 58.0576 43.7007 58.1316C44.0926 58.1809 44.5537 58.4276 45.3376 58.9951C45.3606 58.9951 45.3606 58.9951 45.3606 59.0198C45.4184 59.0661 45.7385 59.2964 46.1906 59.2983C46.4603 59.2994 46.9974 60.0823 47.3333 59.8334C47.61 59.636 47.3831 59.0444 47.5444 59.3405C47.7058 59.6119 47.9889 59.7846 47.7353 59.982C47.205 60.3767 46.6747 60.5001 46.1906 60.5001C45.522 60.5001 44.9687 60.2287 44.669 60.0066C44.4384 59.8339 43.7929 59.3898 43.5162 59.3405C43.4701 59.3405 43.4471 59.3405 43.1935 59.5132C42.9168 59.7599 42.4557 60.1053 41.6257 60.3027C40.8188 60.5248 40.4038 60.2287 40.2194 59.9326C40.0119 59.6119 39.9427 59.1925 40.058 58.625C39.5738 58.9704 39.1127 59.2665 38.9283 59.3652C38.5364 59.6612 37.7295 60.2534 37.1992 59.7106C36.9225 59.4392 36.8764 59.0691 37.0378 58.4523C35.8389 59.3898 34.7323 59.8339 33.7179 59.7846C33.0724 59.7599 32.5882 59.5132 32.2654 59.2912C31.9196 59.0938 31.9196 58.5757 32.2193 58.3289Z",
    fill: "#5EC361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 42.5L34 50.5L54 30.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.22c4327433c5f99cbefe16a6219d9aa1.svg";